import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import VideoDashboard from './components/VideoDashboard';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPassword';
import Logout from './pages/Logout';
import Profile from './pages/ProfilePage';
import AccessDenied from './pages/AccessDenied';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
        <Route path="/logout" element={ <Logout /> } />
        <Route path="/profile" element={ <Profile /> } />
        <Route path="/dashboard" element={<VideoDashboard />} />
        <Route path="/403" element={<AccessDenied />} />
        {/* Fallback route */}
        <Route path="*" element={<AccessDenied />} />
      </Routes>
    </Router>
  );
}

export default App;
